import React from 'react';
import { Navbar } from 'react-bootstrap';
import SupportIcon from './SupportIcon';
import PatronAssets from '../../containers/PatronAssets';
import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <Navbar fixedBottom fluid>
        <Navbar.Header>
          <PatronAssets />
          <SupportIcon />
        </Navbar.Header>
      </Navbar>
    </div>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js